import React from 'react';
export function Footer() {
  return <footer className="bg-cream-dark py-12 border-t border-charcoal/10" data-id="element-134">
      <div className="max-w-editorial mx-auto px-4 text-center" data-id="element-135">
        <p className="text-xs text-charcoal/50 font-ui leading-relaxed" data-id="element-136">
          Luisé ist ein kosmetisches Produkt. Es ist kein Arzneimittel und nicht
          dazu bestimmt, Krankheiten zu diagnostizieren, zu behandeln, zu heilen
          oder vorzubeugen. Ergebnisse können variieren. Einzelne
          Erfahrungsberichte spiegeln persönliche Erlebnisse wider. Bei
          anhaltendem oder starkem Haarausfall wende dich bitte an einen
          qualifizierten Arzt.
        </p>
        <div className="mt-8 space-x-4 text-xs text-charcoal/40 font-ui uppercase tracking-wider" data-id="element-137">
          <a href="#" className="hover:text-charcoal/70" data-id="element-138">
            Impressum
          </a>
          <span data-id="element-139">|</span>
          <a href="#" className="hover:text-charcoal/70" data-id="element-140">
            Datenschutz
          </a>
          <span data-id="element-141">|</span>
          <a href="#" className="hover:text-charcoal/70" data-id="element-142">
            AGB
          </a>
        </div>
      </div>
    </footer>;
}